import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Global 401 handler: when a protected request fails auth (e.g. session
// expired while the app stayed open), redirect to login cleanly instead of
// surfacing a raw axios error. Login/auth-check calls are excluded.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = (err.config && err.config.url) || "";
    const isAuthCall = url.includes("/auth/login") || url.includes("/auth/me") || url.includes("/auth/logout");
    if (err.response && err.response.status === 401 && !isAuthCall) {
      if (typeof window !== "undefined" && window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
